import "./team-score-board.component";
import "./team-score-board-list.component";
